import {createSelector} from '@reduxjs/toolkit';
import {RootState} from '../store';

// Base selectors
export const selectAllOrders = (state: RootState) =>
  state.orderTracker.activeOrders;
export const selectOrderTrackerLoading = (state: RootState) =>
  state.orderTracker.loading;
export const selectOrderTrackerError = (state: RootState) =>
  state.orderTracker.error;

// Orders are already filtered in Redux slice
export const selectActiveOrdersForDisplay = createSelector(
  [selectAllOrders],
  (orders) => {
    return orders;
  },
);

// Selector for specific order
export const selectOrderById = (state: RootState, orderId: string) => {
  return state.orderTracker.activeOrders.find((order) => order.id === orderId);
};

// Selector for orders count
export const selectActiveOrdersCount = createSelector(
  [selectActiveOrdersForDisplay],
  (orders) => orders.length,
);
